import { UserInfo } from '@/types/auth';
import { DisabledEvaluator, HiddenEvaluator } from '@/types/filter/filterConfig';
import { SelectItem } from '@/types/ui/selectItem';
import { Location as LocationType } from 'react-router-dom';

export const getIsDisabled = (
  disabled: boolean | DisabledEvaluator | undefined,
  options: SelectItem<unknown>[],
  contexts: {
    userInfo: UserInfo | null;
    location: LocationType;
    isSecondaryLevelFilter?: boolean;
  },
): boolean => {
  if (typeof disabled !== 'function') {
    return disabled ?? false;
  }

  const { userInfo } = contexts;
  // An evaluator needs a resolved userInfo, so an unresolved one means "not ready", not "not disabled".
  if (!userInfo) {
    return true;
  }

  return disabled({ options, contexts: { ...contexts, userInfo } });
};

export const getIsHidden = (
  hidden: boolean | HiddenEvaluator | undefined,
  options: SelectItem<unknown>[],
  contexts: { userInfo: UserInfo | null; isSecondaryLevelFilter?: boolean },
): boolean => {
  if (typeof hidden !== 'function') {
    return hidden ?? false;
  }

  const { userInfo } = contexts;
  // Staying hidden until userInfo resolves keeps a filter the user must not see from painting first.
  if (!userInfo) {
    return true;
  }

  return hidden({ options, contexts: { ...contexts, userInfo } });
};
